import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 w-full mb-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-lg md:text-2xl text-textPrimary" }, "Editar plantão", -1)
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "text-left mb-4 md:max-w-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "text-left"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-base rounded py-1 px-2 bg-alert/10 border border-alert" }, " Aberta ", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-3 mb-4 px-3 py-2 rounded-md border border-[#F18F1B] bg-[#FEF3E7] text-sm text-textPrimary",
  "data-testid": "update-station-open-station-notice"
}
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col md:flex-row gap-4 md:gap-6 mb-4 md:mb-6"
}
const _hoisted_9 = { class: "station-form-category-container mb-6 text-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Turno", -1)
const _hoisted_11 = { class: "station-form-category-container mb-6 text-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Regra de proporcionalidade", -1)
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = {
  key: 1,
  class: "-mt-4 mb-6 text-sm text-textSecondary text-left",
  "data-testid": "update-station-sector-no-unit"
}
const _hoisted_15 = ["inert", "aria-disabled"]
const _hoisted_16 = {
  key: 0,
  class: "station-form-category-container mb-6 mt-4 text-left"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Valores do plantão", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "flex flex-wrap gap-3 md:gap-4 justify-start mb-4 md:mb-6" }
const _hoisted_20 = {
  key: 3,
  class: "mt-6 text-left",
  "data-testid": "station-check-attempts-block"
}
const _hoisted_21 = { class: "flex flex-row items-center justify-between mb-1 flex-wrap gap-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-black" }, "Tentativas de check", -1)
const _hoisted_23 = {
  type: "button",
  class: "flex gap-2 md:gap-4 items-center text-primary30"
}
const _hoisted_24 = { class: "font-bold text-sm" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col w-full rounded-lg p-2 border-[2px] border-primary mb-4",
  "data-testid": "station-check-attempts"
}
const _hoisted_26 = {
  key: 5,
  class: "flex items-start gap-2 px-3 py-2 mt-6 rounded-md border border-primary30 bg-primary5 text-sm text-textPrimary text-left",
  "data-testid": "update-station-post-station-lock-banner"
}
const _hoisted_27 = { class: "flex flex-col-reverse md:flex-row gap-3 md:gap-5 justify-between" }
const _hoisted_28 = { class: "w-full md:w-auto" }
const _hoisted_29 = { class: "flex flex-row items-center gap-2 md:gap-4 w-full md:w-auto" }
const _hoisted_30 = { class: "flex gap-3" }
const _hoisted_31 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_32 = { class: "flex-1" }
const _hoisted_33 = { class: "flex-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Excluir Plantão", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, [
  /*#__PURE__*/_createTextVNode(" Tem certeza que deseja excluir o plantão?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Essa ação não poderá ser desfeita! ")
], -1)
const _hoisted_36 = { class: "flex justify-center gap-4" }
const _hoisted_37 = { class: "font-bold text-lg text-left" }
const _hoisted_38 = { class: "w-full text-sm table-auto border" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-gray-100" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left p-2" }, "Domínio"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left p-2" }, "Política"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left p-2" }, "Autorizado"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left p-2" }, "Bloqueado")
  ])
], -1)
const _hoisted_40 = { class: "p-2" }
const _hoisted_41 = { class: "p-2" }
const _hoisted_42 = { class: "p-2" }
const _hoisted_43 = { class: "p-2" }
const _hoisted_44 = {
  key: 0,
  class: "mt-4 p-4 border-l-4 border-red-500 bg-red-50 rounded-md"
}
const _hoisted_45 = { class: "flex items-center" }
const _hoisted_46 = { class: "ml-3 text-sm text-red-700" }
const _hoisted_47 = { class: "capitalize" }
const _hoisted_48 = {
  key: 1,
  class: "mt-4 p-4 border-l-4 border-yellow-500 bg-yellow-50 rounded-md"
}
const _hoisted_49 = { class: "flex items-center" }
const _hoisted_50 = { class: "ml-3 text-sm text-yellow-700" }
const _hoisted_51 = { class: "mt-1" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "não há políticas de autorização", -1)

import { ref, PropType, onMounted, onBeforeUnmount, computed, reactive, watch } from 'vue'
import { mdiLock, mdiMapMarkerRadiusOutline } from '@mdi/js'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import DashboardModalShell from '@/modules/company/Dashboard/mobile/DashboardModalShell.vue'
import MobileOverlayLayer from '@/modules/company/Dashboard/mobile/MobileOverlayLayer.vue'
import HourAndDateForm from '@/modules/company/Dashboard/modals/createStation/components/form/hours.and.date.form.vue'
import ObservationForm from '@/modules/company/Dashboard/components/observation.form.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import StationIdBadge from '@/components/designSystem/Badges/StationIdBadge.vue'
import {
  HistoryDate,
  HistoryDateRequest,
  Observation,
  UpdateStationRequest,
  StationTypes
} from '@/Network/Types/Requests/StationRequests'
import NetworkService from '@/Network/index'
import ConsecutiveHoursBlockAlert from '@/components/designSystem/Alerts/ConsecutiveHoursBlockAlert.vue'
import ScheduleOverlapAlert from '@/components/designSystem/Alerts/ScheduleOverlapAlert.vue'
import { useConsecutiveHoursCheck } from '@/hooks/useConsecutiveHoursCheck'
import { useStationOverlapAlerts } from '@/hooks/useStationOverlapAlerts'
import type { ConsecutiveHoursCheckCandidate } from '@/Network/Types/Requests/StationRequests'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { getApiErrorStatus } from '@/utils/apiError'
import { useStationStore } from '@/pinia-store/useStationStore'
import { useDsAttendanceStore } from '@/pinia-store/useDsAttendanceStore'
import {
  getHistoriesRequest,
  getStartDateAndEndDate,
  StationToUpdate,
  buildUpdateCoverageInput
} from '../createStation/helpers'
import UnidentifiedCoverageCard from '@/components/Coverage/UnidentifiedCoverageCard.vue'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { getCoverageErrorMessage } from '@/utils/coverageErrors'
import PlaceholderDoctorBlockedModal from '@/components/Coverage/PlaceholderDoctorBlockedModal.vue'
import { usePlaceholderDoctorBlocked } from '@/composables/usePlaceholderDoctorBlocked'
import DoctorChecks from './components/doctor.checks.vue'
import CheckAttemptsPanel from '@/components/CheckAttempts/CheckAttemptsPanel.vue'
import StationDetailsModal from '../../components/stationDetailsModal.vue'
import { DoctorAuthorizationResponse } from '@/Network/Types/Responses/DsPolicyResponses'
import CardDutyFee from '@/components/designSystem/Cards/CardDutyFee.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import StatusSummaryBadge from '@/components/designSystem/Badges/StatusSummaryBadge.vue'
import { ExceptionSummaryStatus } from '@/Network/Types/Responses/StationResponses'
import { getProportionalityRuleTitle } from '@/utils/schedule'
import CardDutyWithDoctor from '@/components/designSystem/Cards/CardDutyWithDoctor.vue'
import ValueDetailsSection from '../../components/ValueDetailsSection.vue'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import SVGIcon from '@/components/SVGIcon.vue'
import { POST_STATION_LOCK_BANNER_TEXT } from '@/modules/company/PostStation/constants'
import { usePostStationLock } from '@/modules/company/PostStation/composables/usePostStationLock'
import { getPostStationApprovedMessage } from '@/modules/company/PostStation/errors'
import {
  isStationCheckInLocked,
  isStationDurationExceeded
} from '@/modules/company/Dashboard/modals/stationErrors'
import SectorSpecialtyFields from '@/components/SectorSpecialty/SectorSpecialtyFields.vue'
import type { StationSectorRef } from '@/Network/Types/Responses/StationResponses'
import {
  buildSectorSpecialtyPatch,
  hasSectorSpecialtyChanges,
  patchToBulkRequest,
  specialtyRefToSelection,
  type SpecialtySelection
} from '@/utils/sectorSpecialty'
import { catalogDisplayName } from '@/utils/stationDisplay'

const OPEN_STATION_NOTICE = 'Vaga aberta: aqui só setor e especialidade são salvos.'

/** Só os campos que o usuário alterou; ausente = mantém, null = limpa (spec §4.2). */
type StatusItem = {
  domain: string
  policyName: string
  authorized: boolean | null
  blocked: boolean | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'update.station.modal',
  props: {
  showModal: { type: Boolean, default: false },
  infos: { type: Object as PropType<StationToUpdate>, required: true },
  exceptionStatus: { type: String as PropType<ExceptionSummaryStatus>, required: false },
  /** R6: tela cheia no celular. O IndexV2 liga com `isMobileLayout`. */
  mobileShell: { type: Boolean, default: false }
},
  emits: ['closeModal', 'goBack', 'saved'],
  setup(__props, { emit }) {

const props = __props;



const { flags } = useFeatureFlags()
const permissionsStore = usePermissionsStore()
const dsAttendanceStore = useDsAttendanceStore()

/**
 * Q4/§4.4 — a aba de checks é somente leitura quando o bloqueio global da
 * inserção manual está ligado. A verdade vem do backend, nunca de uma variável
 * de front: preferimos o campo aditivo de `GET /stations/:id` (quando chegar) e
 * caímos em `registration-settings`, que nasce `false` — o comportamento de
 * hoje, que é também o caminho de rollback de §10.5.
 */
const manualCheckBlockEnabled = computed<boolean>(() => {
  const fromStationDetails = (props.infos as { manualCheckBlockEnabled?: boolean })
    ?.manualCheckBlockEnabled
  if (typeof fromStationDetails === 'boolean') return fromStationDetails
  return dsAttendanceStore.isManualCheckBlocked
})

const canManageEvidences = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationChecksEvidencesManaging,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const canDeleteStation = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationDeleting,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

/**
 * O `CardDutyWithDoctor` usa o `scheduleId` como recurso da checagem de
 * permissão que libera o bloco de requisitos (Formação / Equipe / Posição /
 * Turno). Sem a prop, o gate do card retorna `false` e o bloco nunca aparece.
 *
 * O fallback para `infos.schedule.id` não é defensivo à toa: os callers montam
 * `infos` à mão e o `handleEditStation` de ambos (`Dashboard/Index.vue` e
 * `Consult/ShiftChangeHistory.vue`) grava `schedule` mas NÃO regrava
 * `scheduleId`. Quando o payload de origem vem sem `station.schedule` — caso do
 * histórico de troca — sobra só `infos.schedule.id`, e ler apenas `scheduleId`
 * esconderia o bloco de quem tem a permissão.
 *
 * `undefined` (nunca `NaN`) quando não há id em nenhum dos dois, porque a prop
 * do card é `scheduleId?: number` e `NaN` passaria pelo `!props.scheduleId`.
 */
const cardScheduleId = computed<number | undefined>(() => {
  const rawScheduleId = props.infos?.scheduleId ?? props.infos?.schedule?.id
  const scheduleId = Number(rawScheduleId)
  return Number.isFinite(scheduleId) && scheduleId > 0 ? scheduleId : undefined
})

/**
 * Trava de edição do Pós-Plantão (RN-07 / RF-12): plantão aprovado tem os dados
 * críticos protegidos, e o ajuste passa obrigatoriamente pela reversão
 * justificada (US-06).
 *
 * A sondagem é feita aqui, e não recebida por prop, de propósito: este modal tem
 * DOIS callers (`Dashboard/Index.vue` e `Consult/ShiftChangeHistory.vue`), que
 * montam `infos` à mão a partir de shapes diferentes — prop-drilling exigiria
 * mapear nos dois e manter em sincronia. O status também não vem no detalhe do
 * plantão (`ShiftDetails` não tem campo de pós-plantão).
 *
 * O gate de leitura usa `cardScheduleId` (e não `infos.scheduleId` cru) pelo
 * mesmo motivo documentado nele: vindo do histórico de troca, sobra só
 * `infos.schedule.id`, e ler apenas `scheduleId` fazia o gate dar false — a
 * sondagem não acontecia e a trava preventiva não subia por lá.
 */
const {
  isPostStationLocked,
  refresh: refreshPostStationLock,
  applyApprovedError: applyPostStationApprovedError
} = usePostStationLock(
  () => props.infos?.stationId,
  () => cardScheduleId.value
)
// `saved`: edição gravada; quem abriu o modal volta para os detalhes do plantão.

const validationState = ref({ isValid: false, message: null as string | null })

const handleValidation = (status: { isValid: boolean; message: string | null }) => {
  validationState.value = status
}

function safeFormat(
  dateString: string | null | undefined,
  formatString: string,
  timezone: string,
  fallback = ''
): string {
  if (!dateString) {
    return fallback
  }
  try {
    const date = utcToZonedTime(dateString, timezone)
    if (isNaN(date.getTime())) {
      return fallback
    }
    return format(date, formatString)
  } catch (error) {
    console.error(`Erro ao formatar data: ${dateString}`, error)
    return fallback
  }
}

// Aviso do médico "coringa" (422 PLACEHOLDER_DOCTOR_BLOCKED) em vez do toast.
const placeholderBlocked = usePlaceholderDoctorBlocked()

const createDefaultForm = () => ({
  doctor: undefined as string | undefined,
  doctorName: '',
  userSponsorId: null,
  value: 0,
  inCash: false,
  advanceRequested: false,
  advancePaid: false,
  modifiedValue: false,
  observations: [] as Observation[],
  date: '',
  endDate: '',
  startHour: '',
  endHour: '',
  finishedAtUntil: '',
  timezone: '',
  stationType: 'FIXO' as StationTypes,
  histories: [] as HistoryDate[],
  formation: '',
  team: '',
  position: '',
  shift: {
    id: 0,
    name: ''
  },
  sector: null as StationSectorRef | null,
  specialty: null as SpecialtySelection | null,
  ourTeam: false
})
const form = reactive(createDefaultForm())

/** Valor gravado no plantão ao abrir o modal: base da semântica de patch (P4). */
const initialSectorSpecialty = ref<{
  sector: StationSectorRef | null
  specialty: SpecialtySelection | null
}>({
  sector: null,
  specialty: null
})

const healthUnitIdForSector = computed<number | null>(() => {
  const id = Number(props.infos.schedule?.healthUnit?.id)
  return Number.isFinite(id) && id > 0 ? id : null
})

/** E-06 / Q31: estado explícito para o PUT de plantão sem médico (null = fluxo com médico). */
const coverageInput = computed(() => buildUpdateCoverageInput(props.infos))
const isUnidentifiedStation = computed(
  () => props.infos.coverageStatus === CoverageStatus.UNIDENTIFIED
)

// A11: o caminho de vaga aberta (lote com 1 id, campos travados) só existe com a flag ligada;
// desligada, a vaga aberta segue a regra da base (PUT). Ocupado sem identificação NUNCA
// entra aqui: com a flag ligada ou desligada, edita horário/valor pelo PUT (E-06).
const isOpenStation = computed(
  () =>
    !!flags.enabledDashboardV2 && !props.infos.doctorStation?.doctor && !isUnidentifiedStation.value
)
const sectorSpecialtyPatch = computed(() =>
  buildSectorSpecialtyPatch(initialSectorSpecialty.value, {
    sector: form.sector,
    specialty: form.specialty
  })
)

const describeSectorSpecialty = (
  sector: StationSectorRef | null,
  specialty: SpecialtySelection | null
) => `${catalogDisplayName(sector, '— sem setor')} · ${specialty?.name ?? '— sem especialidade'}`

/**
 * F3 (nota do BE): a resposta do PUT não traz setor/especialidade atualizados. Com o modal
 * ainda aberto depois de salvar, a classificação exibida (e a base do patch) vem de um
 * `GET /stations/:id` fresco.
 */
async function reloadSectorSpecialtyFromServer(): Promise<void> {
  try {
    const fresh = await NetworkService.station.getStationDetails(props.infos.stationId)
    // Sem corpo: mesmo tratamento da falha (mantém a escolha do usuário).
    if (!fresh) return
    form.sector = fresh.sector ?? null
    form.specialty = specialtyRefToSelection(fresh.specialty)
    initialSectorSpecialty.value = { sector: form.sector, specialty: form.specialty }
  } catch {
    // fallback intencional: a gravação já deu certo e foi avisada; sem o GET o modal
    // continua com o que o usuário escolheu (o detalhe relê o plantão ao reabrir).
  }
}

/** H6: prévia antes → depois, só quando algo mudou. */
const sectorSpecialtyPreview = computed(() =>
  hasSectorSpecialtyChanges(sectorSpecialtyPatch.value)
    ? `Antes: ${describeSectorSpecialty(
        initialSectorSpecialty.value.sector,
        initialSectorSpecialty.value.specialty
      )} → Depois: ${describeSectorSpecialty(form.sector, form.specialty)}`
    : null
)

const {
  violations: consecutiveHoursViolations,
  hasViolations: hasConsecutiveHoursViolations,
  runCheck: runConsecutiveHoursCheck,
  applyErrorViolations: applyConsecutiveHoursError,
  clearViolations: clearConsecutiveHoursViolations
} = useConsecutiveHoursCheck()

// Conflito de agenda: aviso a posteriori (o backend devolve junto do plantao ja gravado).
// Nao bloqueia o submit — so segura o modal aberto para o usuario ler.
const {
  alerts: overlapAlerts,
  hasAlerts: hasOverlapAlerts,
  applyFromResponse: applyOverlapAlerts
} = useStationOverlapAlerts()

watch(
  () => [form.doctor, form.team, form.date, form.endDate, form.startHour, form.endHour],
  () => clearConsecutiveHoursViolations()
)

function buildConsecutiveHoursCandidates(
  doctorId: number,
  startDate: Date,
  endDate: Date
): ConsecutiveHoursCheckCandidate[] {
  const scheduleId = Number(props.infos.scheduleId)
  if (!Number.isFinite(scheduleId)) return []
  const doctorStationId = props.infos.doctorStation?.id
  return [
    {
      scheduleId,
      doctorId,
      stationId: props.infos.stationId,
      startHour: startDate.toISOString(),
      endHour: endDate.toISOString(),
      ourTeam: form.team === 'Interno',
      timezone: form.timezone,
      // A própria alocação sendo editada não pode contar contra si mesma.
      excludeDoctorStationIds: doctorStationId ? [doctorStationId] : undefined
    }
  ]
}

const formErrors = ref<{
  userSponsorId?: string
}>({})
const isSavingLoading = ref(false)
const isExcludingLoading = ref(false)
const showModalDelete = ref(false)
const activeIndex = ref(0)
const showModalUnauthorized = ref(false)
const isDoctorValidated = ref(false)
const doctorAuthorization = ref<DoctorAuthorizationResponse | null>(null)
const hasPendingChecks = ref(false)
const isAllocatable = ref(true)

/**
 * Seção "Tentativas de check": fica recolhida por padrão e só monta o painel no
 * clique. O `source` é um computed (e não um objeto literal no template) porque
 * o `CheckAttemptsPanel` observa a prop com `deep: true` — um literal recriado a
 * cada re-render dispararia uma busca nova a cada digitação no formulário.
 */
const showCheckAttempts = ref(false)
const checkAttemptsSource = computed(() => ({ stationId: Number(props.infos.stationId) }))

watch(
  () => props.infos?.stationId,
  () => {
    showCheckAttempts.value = false
  }
)

const toast = useToast()
const { notifyError } = useErrorToast()
const stationStore = useStationStore()

const mapTimezones = {
  '-02:00': 'America/Noronha',
  '-03:00': 'America/Sao_Paulo',
  '-04:00': 'America/Manaus',
  '-05:00': 'America/Rio_Branco'
}
const scheduleProportionalityRule = ref<string | null>('N/A')

// eslint-disable-next-line complexity
onMounted(() => {
  if (props.showModal && props.infos) {
    // Sem `await`: a trava é uma restrição, não um dado do formulário. Deixar o
    // modal montar na hora e o botão desabilitar quando a resposta chega é
    // melhor que um skeleton — e o backend recusa de todo modo.
    refreshPostStationLock()

    // Mesma razão do `refreshPostStationLock` acima: a aba de checks monta no
    // comportamento de hoje (`false`) e só entra em somente leitura quando a
    // resposta chega. A ação nunca lança — backend antigo cai no default seguro.
    void dsAttendanceStore.fetchRegistrationSettings(cardScheduleId.value)

    scheduleProportionalityRule.value = getProportionalityRuleTitle(
      props.infos.schedule?.proportionalityRule
    )

    const tz = props.infos.timezone
    const mappedTz = mapTimezones[tz as keyof typeof mapTimezones] || tz

    const incomingDoctorId = props.infos.doctorStation?.doctor?.id
    const incomingMainCrm = props.infos.doctorStation?.doctor?.mainCrm
    isAllocatable.value = !!incomingDoctorId && !!incomingMainCrm

    if (incomingDoctorId && !isAllocatable.value) {
      toast.warning('Vaga sem médico válido alocado. Selecione um médico para salvar.')
    }

    Object.assign(form, {
      doctor: isAllocatable.value ? String(incomingDoctorId) : undefined,
      doctorName: props.infos.doctorStation?.doctor?.mainCrm?.name,
      value: props.infos.value,
      inCash: !!props.infos.inCash,
      advancePaid: !!props.infos.advancePaid,
      advanceRequested: !!props.infos.advanceRequested,
      modifiedValue: !!props.infos.modifiedValue,
      date: safeFormat(props.infos.date.toString(), 'dd/MM/yyyy', mappedTz, ''),
      endDate: safeFormat(props.infos.endHour?.toString(), 'dd/MM/yyyy', mappedTz, ''),
      startHour: safeFormat(props.infos.startHour?.toString(), 'HH:mm', mappedTz, ''),
      endHour: safeFormat(props.infos.endHour?.toString(), 'HH:mm', mappedTz, ''),
      finishedAtUntil: safeFormat(props.infos.endHour?.toString(), 'dd/MM/yyyy', mappedTz, ''),
      timezone: tz,
      stationType: props.infos.stationType,
      histories: props.infos.checks ?? [],
      ourTeam: !!props.infos.ourTeam,
      formation: (props.infos as any).doctorStation?.dsPaymentDoctorFormation?.id || '',
      team: props.infos.ourTeam ? 'Interno' : 'Externo',
      position: props.infos.position?.name || '',
      shift: (props.infos as any).shift || '',
      userSponsorId: props.infos.userSponsor?.id,
      sector: props.infos.sector ?? null,
      specialty: specialtyRefToSelection(props.infos.specialty)
    })
    initialSectorSpecialty.value = { sector: form.sector, specialty: form.specialty }
    isDoctorValidated.value = false
    doctorAuthorization.value = null
    const matchingCardIndex = dutyFeeCards.value.findIndex((c) => c.value === form.value)
    activeIndex.value = matchingCardIndex !== -1 ? matchingCardIndex : 0
  }
})

const dutyFeeCards = computed(() => {
  const policies = props.infos.schedule?.paymentPolicies
  if (!policies || policies.length === 0) return []
  return policies[0].rules.map((rule: any) => ({
    formation: rule.ruleFormations?.[0]?.name || null,
    value: parseFloat(rule.hourValue),
    repassMode: rule.paymentTiming
  }))
})

const isDoctorChanged = computed(() => {
  const current = form.doctor ? Number(form.doctor) : undefined
  const original = props.infos.doctorStation?.doctor?.id
  return current !== original
})
const isSaveDisabled = computed(() => {
  // Vaga aberta: o PUT exige médico, então só dá para salvar setor/especialidade (H6).
  if (isOpenStation.value) {
    return isPostStationLocked.value || !hasSectorSpecialtyChanges(sectorSpecialtyPatch.value)
  }
  return (
    // Sem médico só salva quando o BE informa o estado da cobertura (OPEN/UNIDENTIFIED).
    (!isAllocatable.value && !coverageInput.value) ||
    hasConsecutiveHoursViolations.value ||
    isPostStationLocked.value ||
    (isDoctorChanged.value && !isDoctorValidated.value && !!form.doctor)
  )
})

watch(
  () => form.doctor,
  (newDoctorId, oldDoctorId) => {
    if (oldDoctorId === undefined || newDoctorId === oldDoctorId) {
      return
    }
    form.formation = ''
    form.userSponsorId = null
    isDoctorValidated.value = false
  }
)

const domainTranslation: Record<string, string> = {
  POSITION: 'Posição',
  SCHEDULE: 'Escala',
  HEALTH_UNIT: 'Unidade de Saúde',
  COMPANY: 'Empresa'
}

const checklistStatus = ref<Record<string, { authorized: StatusItem; blocked: StatusItem }>>({
  POSITION: {
    authorized: { domain: 'POSITION', policyName: '-', authorized: null, blocked: null },
    blocked: { domain: 'POSITION', policyName: '-', authorized: null, blocked: null }
  },
  SCHEDULE: {
    authorized: { domain: 'SCHEDULE', policyName: '-', authorized: null, blocked: null },
    blocked: { domain: 'SCHEDULE', policyName: '-', authorized: null, blocked: null }
  },
  HEALTH_UNIT: {
    authorized: { domain: 'HEALTH_UNIT', policyName: '-', authorized: null, blocked: null },
    blocked: { domain: 'HEALTH_UNIT', policyName: '-', authorized: null, blocked: null }
  },
  COMPANY: {
    authorized: { domain: 'COMPANY', policyName: '-', authorized: null, blocked: null },
    blocked: { domain: 'COMPANY', policyName: '-', authorized: null, blocked: null }
  }
})

const allAuthorizedNull = computed(() =>
  Object.values(checklistStatus.value).every((item) => item.authorized.authorized === null)
)

const formatDoctorName = (name: string) => {
  if (!name) return ''
  return name
    .toLocaleLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toLocaleUpperCase() + word.slice(1))
    .join(' ')
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const handleSubmit = async () => {
  formErrors.value = {}

  // pode salvar mesmo com o modo de edição aberto nos checks
  // if (hasPendingChecks.value) {
  //   return toast.error(
  //     'Existe Rascunho de registro de presença. Salve ou descarte antes de confirmar a edição.'
  //   )
  // }

  if (hasDutyRegisterPendingChanges.value) {
    return toast.error(
      'Você tem alterações pendentes no "Registro de plantão". Salve o rascunho antes de continuar.'
    )
  }

  // H6: vaga aberta não passa pelo PUT (que exige médico); setor/especialidade vão
  // pelo endpoint de lote com 1 id (A8).
  if (isOpenStation.value) {
    if (!hasSectorSpecialtyChanges(sectorSpecialtyPatch.value)) return
    try {
      isSavingLoading.value = true
      await NetworkService.station.bulkSectorSpecialty(
        patchToBulkRequest([props.infos.stationId], sectorSpecialtyPatch.value)
      )
      toast.success('Setor e especialidade salvos')
      await stationStore.getListStations()
      emit('saved')
    } catch (err: unknown) {
      notifyError(err, 'Não foi possível salvar setor e especialidade')
    } finally {
      isSavingLoading.value = false
    }
    return
  }

  if (!form.stationType) return toast.error('Selecione o tipo de periodicidade do plantão.')
  if (!form.date || !form.startHour || !form.endHour || !form.timezone)
    return toast.error('Preencha a data, horário e fuso horário do plantão.')
  if (!validationState.value.isValid)
    return toast.error(`Erro no preenchimentos das datas: ${validationState.value.message || ''}`)

  if (props.infos.schedule?.requiresDoctorPaymentFormation && !form.formation && !!form.doctor) {
    return toast.error('Informe a formação do médico.')
  }

  if (!form.team) return toast.error('Informe o time do médico.')
  if (!form.userSponsorId && !!form.doctor) {
    formErrors.value = {
      ...formErrors.value,
      userSponsorId: 'Campo Médico escalado por é obrigatório'
    }
    return toast.error('Informe por quem o médico foi alocado.')
  }

  try {
    isSavingLoading.value = true

    const { date, startHour, endHour, timezone, endDate: endDateSelected } = form

    const { startDate, endDate } = getStartDateAndEndDate({
      date,
      startHour,
      endHour,
      timezone,
      endDateSelected
    })

    const originChecks = getHistoriesRequest(form.histories, startDate, endDate)

    // Plantão sem médico com estado informado (OPEN/UNIDENTIFIED): nunca manda médico.
    const coverage = coverageInput.value
    const formDoctorId = !coverage && form.doctor ? Number(form.doctor) : undefined
    const resolvedDoctorId = Number.isFinite(formDoctorId) ? formDoctorId : undefined

    if (!resolvedDoctorId && !coverage) {
      toast.error(
        'Esta vaga possui médico inválido. Para alterar, acesse o gerenciamento de alocações.'
      )
      return
    }

    if (resolvedDoctorId) {
      const canProceed = await runConsecutiveHoursCheck(
        buildConsecutiveHoursCandidates(resolvedDoctorId, startDate, endDate)
      )
      if (!canProceed) {
        toast.error('Limite de horas consecutivas excedido. Veja os detalhes no formulário.')
        return
      }
    }

    // O backend recusa lançamento manual de check em UNIDENTIFIED: `histories` é omitido
    // (ausente = mantém), pela mesma razão do bloqueio global abaixo.
    const omitHistories = manualCheckBlockEnabled.value || isUnidentifiedStation.value

    /**
     * `histories` é OMITIDO — e não enviado como `[]` — quando a aba de checks
     * está somente leitura. O `PUT` apaga todo check ausente de `histories[]`, e
     * um array vazio passa pelo guard do backend: mandar `[]` daqui apagaria os
     * checks do plantão sem ninguém ter clicado em nada. O backend com a flag
     * ligada também ignora o campo — são duas travas para o mesmo buraco.
     */
    const payload: Omit<UpdateStationRequest, 'histories'> & {
      histories?: HistoryDateRequest[]
    } = {
      doctorId: resolvedDoctorId,
      userSponsorId: coverage ? null : form.userSponsorId,
      formation: !coverage && form.formation ? Number(form.formation) : undefined,
      position: Number(form.position),
      team: form.team,
      advancePaid: form.advancePaid,
      advanceRequested: form.advanceRequested,
      stationType: form.stationType as StationTypes,
      config: { date: startDate, startHour: startDate, endHour: endDate, timezone: form.timezone },
      observations: form.observations,
      value: Number(form.value),
      inCash: form.inCash,
      ourTeam: isUnidentifiedStation.value ? false : form.team === 'Interno',
      ...(omitHistories ? {} : { histories: originChecks || [] }),
      modifiedValue: form.modifiedValue,
      ...(flags.enabledDashboardV2 ? sectorSpecialtyPatch.value : {}),
      ...(coverage ?? {})
    }

    const formData = new FormData()
    formData.append('data', JSON.stringify(payload))

    // Mesma razão: sem `histories` no payload, nenhum `historyEvidence[i][]`
    // deve viajar junto — não há linha para ancorá-lo.
    if (form.histories && !omitHistories) {
      form.histories.forEach((history, index) => {
        // Agora 'history' é do tipo HistoryDate (que TEM 'evidence')
        if (history.evidence && Array.isArray(history.evidence)) {
          history.evidence.forEach((file) => {
            if (file instanceof File) {
              formData.append(`historyEvidence[${index}][]`, file)
            }
          })
        }
      })
    }

    const updated = await NetworkService.station.update(
      props.infos.stationId,
      formData,
      Number(props.infos.scheduleId)
    )
    toast.success('Plantão editado com sucesso')
    await stationStore.getListStations()

    // A edicao ja esta gravada; se o backend acusou sobreposicao, o modal fica aberto
    // exibindo o aviso ambar em vez de fechar e engolir a informacao.
    if (applyOverlapAlerts(updated)) {
      if (flags.enabledDashboardV2) await reloadSectorSpecialtyFromServer()
      return
    }

    emit('saved')
  } catch (err: unknown) {
    // Guards F10: o service normaliza via handleError (ServiceError) e os guards
    // fazem unwrap do axios original — os ramos específicos ficam como estão.
    if (applyConsecutiveHoursError(err)) {
      toast.error('Limite de horas consecutivas excedido. Veja os detalhes no formulário.')
      return
    }

    if (isStationDurationExceeded(err)) {
      toast.error('A duração do plantão não pode ser superior a 24 horas.')
      return
    }

    // A trava do Pós-Plantão pode aparecer aqui mesmo com o botão habilitado: a
    // varredura pode aprovar o plantão enquanto o modal está aberto. O backend
    // manda uma frase pronta em pt-BR — repassar em vez de reescrever.
    if (applyPostStationApprovedError(err)) {
      toast.error(getPostStationApprovedMessage(err))
      return
    }

    if (placeholderBlocked.handleError(err, props.infos.doctorStation?.doctor?.mainCrm?.name)) {
      return
    }

    const coverageMessage = getCoverageErrorMessage(err)
    if (coverageMessage) {
      toast.error(coverageMessage)
      return
    }

    if (getApiErrorStatus(err) === 400 && isStationCheckInLocked(err)) {
      toast.error('Este plantão já possui check-in realizado e não pode ser editado.')
    } else {
      // Antes: "Ops, não foi possível processar a requisição" — a mensagem
      // específica do backend (via ServiceError) chega intacta ao usuário.
      notifyError(err, 'Não foi possível editar o plantão')
    }
  } finally {
    isSavingLoading.value = false
  }
}

const handleDeleteStation = async () => {
  try {
    isExcludingLoading.value = true

    await NetworkService.station.delete(props.infos.stationId, props.infos.schedule.id)
    toast.success('Plantão removido com sucesso')
    await stationStore.getListStations()
    showModalDelete.value = false
  } catch (err: unknown) {
    if (getApiErrorStatus(err) === 400 && isStationCheckInLocked(err)) {
      toast.error('Este plantão já possui check-in realizado e não pode ser removido.')
    } else if (applyPostStationApprovedError(err)) {
      // Mesmo caso do submit: a aprovação pode chegar com o modal aberto.
      toast.error(getPostStationApprovedMessage(err))
    } else {
      // Antes: "Ops, não foi possível processar a requisição" genérico.
      notifyError(err, 'Não foi possível remover o plantão')
    }
    showModalDelete.value = false
  } finally {
    isExcludingLoading.value = false
    emit('closeModal')
  }
}

const updateChecks = (h: HistoryDate[]) => {
  form.histories = h
}

const hasDutyRegisterPendingChanges = ref(false)

function handleChildChanges(isDirty: boolean) {
  console.log('handleChildChanges called')
  console.log('handleChildChanges called with isDirty:', isDirty)
  hasDutyRegisterPendingChanges.value = isDirty
}

const handleEditModeChanged = (isEditing: boolean) => {
  hasPendingChecks.value = isEditing
}

/**
 * Registro de Permanência (chip 🔗 + linha de vínculo em `doctor.checks.vue`):
 * navegação real, empilhada sobre este modal, para o `StationDetailsModal`
 * (read-only) do plantão vinculado — em vez do evento sem destino de antes.
 */
const linkedStationModal = ref<{ show: boolean; stationId: number | null }>({
  show: false,
  stationId: null
})

function handleNavigateToLinkedStation(stationId: number) {
  linkedStationModal.value = { show: true, stationId }
}

function closeLinkedStationModal() {
  linkedStationModal.value.show = false
  // Zera o stationId para desmontar o StationDetailsModal (pesado) em vez de
  // deixá-lo montado (apenas oculto) atrás deste modal.
  linkedStationModal.value.stationId = null
}

const setActiveIndex = (index: string | number) => {
  if (isOpenStation.value) return
  const i = Number(index)
  if (dutyFeeCards.value[i]) {
    activeIndex.value = i
    form.value = dutyFeeCards.value[i].value
  }
}

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && props.showModal) {
    // Modal empilhado (StationDetailsModal do plantão vinculado) está aberto:
    // deixa o Escape dele fechar primeiro, em vez de fechar os dois de uma vez.
    if (linkedStationModal.value.show) return
    // Idem para o aviso do médico coringa.
    if (placeholderBlocked.isOpen.value) return
    emit('closeModal')
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DashboardModalShell, {
      open: __props.showModal,
      "full-screen": __props.mobileShell,
      title: "Editar plantão",
      meta: `#${__props.infos.stationId}`,
      "test-id": "update-station-panel",
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('closeModal'))),
      hasFooterBorder: true,
      hasHeaderBorder: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(StationIdBadge, {
            stationId: __props.infos.stationId,
            doctorStationId: props.infos?.doctorStation?.id
          }, null, 8, ["stationId", "doctorStationId"]),
          _hoisted_2
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            (canDeleteStation.value)
              ? (_openBlock(), _createBlock(GhostButton, {
                  key: 0,
                  "data-testid": "update-station-delete-button",
                  class: "!text-red-500 hover:!text-red-500 hover:!bg-red-100 border border-red-500 w-full md:w-auto",
                  loading: isExcludingLoading.value,
                  disabled: _unref(isPostStationLocked),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (showModalDelete.value = true)),
                  text: "Excluir plantão",
                  height: "48px",
                  width: ""
                }, null, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_unref(hasOverlapAlerts))
              ? (_openBlock(), _createBlock(FilledButton, {
                  key: 0,
                  "data-testid": "update-station-overlap-ack-button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('saved'))),
                  text: "Entendi, fechar",
                  height: "48px",
                  class: "!bg-[#337C88] flex-1 md:flex-none md:w-[180px]"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(OutlinedButton, {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('goBack'))),
                    text: "Voltar",
                    height: "48px",
                    width: "74px"
                  }),
                  _createVNode(FilledButton, {
                    "data-testid": "update-station-submit",
                    loading: isSavingLoading.value,
                    disabled: isSaveDisabled.value,
                    onClick: handleSubmit,
                    text: "Salvar edição",
                    height: "48px",
                    class: "!bg-[#337C88] flex-1 md:flex-none md:w-[180px]"
                  }, null, 8, ["loading", "disabled"])
                ], 64))
          ])
        ])
      ]),
      dock: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          (_unref(hasOverlapAlerts))
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(FilledButton, {
                  "data-testid": "update-station-overlap-ack-button",
                  class: "!bg-[#337C88]",
                  width: "100%",
                  height: "44px",
                  text: "Entendi, fechar",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('saved')))
                })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(OutlinedButton, {
                    width: "100%",
                    height: "44px",
                    text: "Voltar",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('goBack')))
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(FilledButton, {
                    "data-testid": "update-station-submit",
                    class: "!bg-[#337C88]",
                    width: "100%",
                    height: "44px",
                    text: "Salvar",
                    loading: isSavingLoading.value,
                    disabled: isSaveDisabled.value,
                    onClick: handleSubmit
                  }, null, 8, ["loading", "disabled"])
                ])
              ], 64))
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StatusSummaryBadge, {
            status: props.exceptionStatus
          }, null, 8, ["status"])
        ]),
        (isUnidentifiedStation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(UnidentifiedCoverageCard, {
                compact: "",
                "responsible-name": props.infos.coverageResponsibleName
              }, null, 8, ["responsible-name"])
            ]))
          : (!props.infos.doctorStation?.doctor)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (isOpenStation.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(OPEN_STATION_NOTICE)))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(CardDutyWithDoctor, {
                  "data-testid": "update-station-doctor-input",
                  formation: props.infos?.doctorStation?.dsPaymentDoctorFormation?.name || '',
                  team: props.infos?.doctorStation?.ourTeam ? 'Interno' : 'Externo',
                  position: props.infos?.position?.name,
                  shift: props.infos?.shift?.name || '',
                  dutyLabel: props.infos?.doctorStation?.type,
                  doctorName: props.infos?.doctorStation?.doctor?.mainCrm?.name,
                  doctorCrm: `${props.infos?.doctorStation?.doctor?.mainCrm?.number || ''}-${
          props.infos?.doctorStation?.doctor?.mainCrm?.uf || ''
        }`,
                  active: false,
                  scheduleId: cardScheduleId.value,
                  npsScore: props.infos?.doctorNpsScore?.npsScore,
                  avatarUrl: props.infos?.doctorStation?.doctor?.user?.avatarUrl
                }, null, 8, ["formation", "team", "position", "shift", "dutyLabel", "doctorName", "doctorCrm", "scheduleId", "npsScore", "avatarUrl"]),
                _createVNode(ValueDetailsSection, {
                  "original-value": props.infos?.value,
                  "approved-value": props.infos?.value,
                  "request-antecipe": props.infos.doctorStation?.requestAntecipe,
                  "antecipe-was-paid": props.infos.doctorStation?.antecipeWasPaid,
                  "is-exception-mode": false,
                  "approval-status": 'Approved'
                }, null, 8, ["original-value", "approved-value", "request-antecipe", "antecipe-was-paid"])
              ])),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col w-full", __props.mobileShell ? '' : 'max-h-[70vh]'])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["grid gap-3", __props.mobileShell ? 'grid-cols-1' : 'grid-cols-2'])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(form.shift.id > 0 ? form.shift?.name : 'Não informado'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("p", _hoisted_13, _toDisplayString(scheduleProportionalityRule.value), 1)
            ])
          ], 2),
          (_unref(flags).enabledDashboardV2)
            ? (_openBlock(), _createBlock(SectorSpecialtyFields, {
                key: 0,
                class: "mb-6",
                "health-unit-id": healthUnitIdForSector.value,
                "company-id": props.infos.companyId || null,
                sector: form.sector,
                specialty: form.specialty,
                summary: sectorSpecialtyPreview.value,
                description: `Vale só para este plantão (#${props.infos.stationId}). Os outros plantões desta posição e desta escala não mudam.`,
                "onUpdate:sector": _cache[0] || (_cache[0] = ($event: any) => (form.sector = $event)),
                "onUpdate:specialty": _cache[1] || (_cache[1] = ($event: any) => (form.specialty = $event))
              }, null, 8, ["health-unit-id", "company-id", "sector", "specialty", "summary", "description"]))
            : _createCommentVNode("", true),
          (_unref(flags).enabledDashboardV2 && !healthUnitIdForSector.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Unidade não identificada para listar setores. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col", { 'opacity-50 pointer-events-none select-none': isOpenStation.value }]),
            inert: isOpenStation.value || undefined,
            "aria-disabled": isOpenStation.value || undefined,
            "data-testid": "update-station-schedule-fields"
          }, [
            _createVNode(HourAndDateForm, {
              date: form.date,
              "onUpdate:date": _cache[2] || (_cache[2] = ($event: any) => ((form.date) = $event)),
              timezone: form.timezone,
              "onUpdate:timezone": _cache[3] || (_cache[3] = ($event: any) => ((form.timezone) = $event)),
              "start-hour": form.startHour,
              "onUpdate:startHour": _cache[4] || (_cache[4] = ($event: any) => ((form.startHour) = $event)),
              "end-hour": form.endHour,
              "onUpdate:endHour": _cache[5] || (_cache[5] = ($event: any) => ((form.endHour) = $event)),
              endDate: form.endDate,
              "onUpdate:endDate": _cache[6] || (_cache[6] = ($event: any) => ((form.endDate) = $event)),
              finishedAtUntil: form.finishedAtUntil,
              "onUpdate:finishedAtUntil": _cache[7] || (_cache[7] = ($event: any) => ((form.finishedAtUntil) = $event)),
              "is-update-mode": true,
              onValidationStatus: handleValidation
            }, null, 8, ["date", "timezone", "start-hour", "end-hour", "endDate", "finishedAtUntil"]),
            (dutyFeeCards.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dutyFeeCards.value, (card, index) => {
                return (_openBlock(), _createBlock(CardDutyFee, {
                  key: index,
                  formation: card.formation,
                  value: card.value,
                  "repass-mode": card.repassMode,
                  active: activeIndex.value === index,
                  onClick: ($event: any) => (setActiveIndex(index))
                }, null, 8, ["formation", "value", "repass-mode", "active", "onClick"]))
              }), 128))
            ])
          ], 10, _hoisted_15),
          (__props.infos.doctorId && canManageEvidences.value && !isUnidentifiedStation.value)
            ? (_openBlock(), _createBlock(DoctorChecks, {
                key: 2,
                onSaveChecks: updateChecks,
                onEditModeChanged: handleEditModeChanged,
                onHasPendingChanges: handleChildChanges,
                onNavigateToLinkedStation: handleNavigateToLinkedStation,
                "station-id": __props.infos.stationId,
                infos: form.histories,
                "manual-check-block-enabled": manualCheckBlockEnabled.value,
                timezone: form.timezone,
                "health-unit-latitude": __props.infos?.healthUnitLatitude,
                "health-unit-longitude": __props.infos?.healthUnitLongitude
              }, null, 8, ["station-id", "infos", "manual-check-block-enabled", "timezone", "health-unit-latitude", "health-unit-longitude"]))
            : _createCommentVNode("", true),
          (__props.infos.stationId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", {
                    class: "flex items-center justify-center cursor-pointer border border-primary30 rounded-md py-1 px-3",
                    "data-testid": "station-check-attempts-toggle",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (showCheckAttempts.value = !showCheckAttempts.value))
                  }, [
                    _createElementVNode("button", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(showCheckAttempts.value ? 'Ocultar' : 'Ver tentativas'), 1),
                      _createVNode(SVGIcon, {
                        path: _unref(mdiMapMarkerRadiusOutline),
                        class: "w-4 h-4 shrink-0"
                      }, null, 8, ["path"])
                    ])
                  ])
                ]),
                (showCheckAttempts.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(CheckAttemptsPanel, {
                        source: checkAttemptsSource.value,
                        compact: ""
                      }, null, 8, ["source"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(flags).enabledObservationsSystem)
            ? (_openBlock(), _createBlock(ObservationForm, {
                key: 4,
                doctorStationId: __props.infos?.doctorStation?.id,
                scheduleId: __props.infos?.scheduleId,
                timezone: __props.infos.timezone
              }, null, 8, ["doctorStationId", "scheduleId", "timezone"]))
            : _createCommentVNode("", true),
          (_unref(isPostStationLocked))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(SVGIcon, {
                  path: _unref(mdiLock),
                  class: "w-4 h-4 mt-0.5 shrink-0 text-primary30"
                }, null, 8, ["path"]),
                _createElementVNode("span", null, _toDisplayString(_unref(POST_STATION_LOCK_BANNER_TEXT)), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(ConsecutiveHoursBlockAlert, {
            violations: _unref(consecutiveHoursViolations),
            class: "mt-6"
          }, null, 8, ["violations"]),
          _createVNode(ScheduleOverlapAlert, {
            alerts: _unref(overlapAlerts),
            mode: "update",
            class: "mt-6"
          }, null, 8, ["alerts"]),
          (__props.mobileShell && canDeleteStation.value)
            ? (_openBlock(), _createBlock(GhostButton, {
                key: 6,
                "data-testid": "update-station-delete-button",
                class: "!text-red-500 hover:!text-red-500 hover:!bg-red-100 border border-red-500 w-full mt-6",
                loading: isExcludingLoading.value,
                disabled: _unref(isPostStationLocked),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (showModalDelete.value = true)),
                text: "Excluir plantão",
                height: "48px",
                width: ""
              }, null, 8, ["loading", "disabled"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["open", "full-screen", "meta"]),
    _createVNode(MobileOverlayLayer, { active: __props.mobileShell }, {
      default: _withCtx(() => [
        _createVNode(ModalVue, {
          onClose: _cache[17] || (_cache[17] = ($event: any) => (showModalDelete.value = false)),
          modalActive: showModalDelete.value,
          maxWidth: "max-w-[400px]"
        }, {
          header: _withCtx(() => [
            _hoisted_34
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(OutlinedButton, {
                width: "119px",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showModalDelete.value = false)),
                text: "Cancelar"
              }),
              _createVNode(FilledButton, {
                loading: isExcludingLoading.value,
                text: "Excluir",
                width: "119px",
                onClick: handleDeleteStation,
                class: "bg-primary30"
              }, null, 8, ["loading"])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        }, 8, ["modalActive"]),
        _createVNode(ModalVue, {
          modalActive: showModalUnauthorized.value,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (showModalUnauthorized.value = false))
        }, {
          header: _withCtx(() => [
            _createElementVNode("p", _hoisted_37, _toDisplayString(`Dr. ${formatDoctorName(form.doctorName)}` || 'Médico') + " não está autorizado para esta vaga. ", 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistStatus.value, (item, domain) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: domain,
                    class: "border-t"
                  }, [
                    _createElementVNode("td", _hoisted_40, _toDisplayString(domainTranslation[domain] || domain), 1),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(item.authorized.policyName), 1),
                    _createElementVNode("td", _hoisted_42, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'text-green-600': item.authorized.authorized === true,
                  'text-red-600': item.authorized.authorized === false,
                  'text-gray-400': item.authorized.authorized === null
                })
                      }, _toDisplayString(item.authorized.authorized === null
                    ? 'Não se aplica'
                    : item.authorized.authorized
                      ? 'Sim'
                      : 'Não'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'text-green-600': item.blocked.blocked === false || item.blocked.blocked === null,
                  'text-red-600': item.blocked.blocked === true
                })
                      }, _toDisplayString(item.blocked.blocked ? 'Sim' : 'Não'), 3)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (doctorAuthorization.value?.crmStatus !== 'Ativo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Não foi possível autorizar o Dr. "),
                        _createElementVNode("b", null, _toDisplayString(formatDoctorName(form.doctorName)), 1),
                        _createTextVNode(" porque a situação atual do CRM é "),
                        _createElementVNode("b", _hoisted_47, _toDisplayString(doctorAuthorization.value?.crmStatus), 1),
                        _createTextVNode(". Apenas profissionais com CRM ativo podem ser alocados. ")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (allAuthorizedNull.value && doctorAuthorization.value?.crmStatus === 'Ativo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("p", _hoisted_51, [
                        _createTextVNode(" Não foi possível validar o Dr. "),
                        _createElementVNode("b", null, _toDisplayString(formatDoctorName(form.doctorName)), 1),
                        _createTextVNode(" para esta vaga, pois "),
                        _hoisted_52,
                        _createTextVNode(" configuradas. ")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modalActive"]),
        (_unref(placeholderBlocked).isOpen.value)
          ? (_openBlock(), _createBlock(PlaceholderDoctorBlockedModal, {
              key: 0,
              modelValue: _unref(placeholderBlocked).isOpen.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(placeholderBlocked).isOpen.value) = $event)),
              "doctor-name": _unref(placeholderBlocked).doctorName.value,
              "allow-unidentified": false
            }, null, 8, ["modelValue", "doctor-name"]))
          : _createCommentVNode("", true),
        (linkedStationModal.value.stationId !== null)
          ? (_openBlock(), _createBlock(StationDetailsModal, {
              key: 1,
              "show-modal": linkedStationModal.value.show,
              infos: { stationId: linkedStationModal.value.stationId },
              "mobile-shell": __props.mobileShell,
              "onUpdate:showModal": _cache[20] || (_cache[20] = ($event: any) => (linkedStationModal.value.show = $event)),
              onCloseModal: closeLinkedStationModal,
              onNavigateToStation: _cache[21] || (_cache[21] = (stationId) => (linkedStationModal.value = { show: true, stationId }))
            }, null, 8, ["show-modal", "infos", "mobile-shell"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}
}

})